import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchPatientHistogramData = async ({ trialId, patientId, token }) => {
  const authToken = token || localStorage.getItem("token");

  const res = await axios.get(
    `${__API_URL__}/api/ecrf/trial/${trialId}/patient/${patientId}/histogram-data/`,
    {
      headers: {
        Authorization: `Token ${authToken}`,
      },
    }
  );

  return res.data;
};

const useGetPatientHistogramData = ({ trialId, patientId, token, enabled = true }) => {
  return useQuery({
    queryKey: ["patient_histogram_data", trialId, patientId],
    queryFn: () => fetchPatientHistogramData({ trialId, patientId, token }),
    enabled: enabled && Boolean(trialId) && Boolean(patientId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load histogram data");
    },
  });
};

export default useGetPatientHistogramData;
